import { Provider } from 'react-redux';
import * as Sentry from '@sentry/react';
import App from './widget';
import './global.scss';
import { store } from '../store';
import { initializeSentry } from '../utils/sentry-config';
import { setupAxiosInterceptors } from '../utils/api-interceptor';
import ErrorBoundary from '../components/ErrorBoundary';

// Initialize enhanced Sentry configuration
initializeSentry();

// Set up global axios interceptors
setupAxiosInterceptors();

// Wrap the entire app with Sentry's error boundary for maximum coverage
const SentryApp = Sentry.withErrorBoundary(App, {
  fallback: ({ resetError }) => (
    <div className="error-boundary">
      <div className="error-boundary-content">
        <h3>Oops! Something went wrong</h3>
        <p>We&apos;ve been automatically notified about this error and are working to fix it.</p>
        <button className="btn btn-primary" onClick={resetError}>
          Try Again
        </button>
      </div>
    </div>
  ),
  beforeCapture: (scope, capturedError, errorInfo) => {
    scope.setTag('errorBoundary', 'root');
    scope.setContext('errorInfo', errorInfo);
  },
});

ReactDOM.render(
  <Provider store={store}>
    <ErrorBoundary name="RootErrorBoundary">
      <SentryApp />
    </ErrorBoundary>
  </Provider>,
  document.getElementById('root')
);

if (module.hot) {
  module.hot.accept();
}
